import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MethodsService {

  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {

  }

  get(endpoint: string, params?: any, reqOpts?: any): Observable<any> {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };

    }
    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        if (params.hasOwnProperty(k)) {
          reqOpts.params = reqOpts.params.set(k, params[k]);
        }
      }
    }
    return this.http.get(this.apiUrl + endpoint, reqOpts);

  }

  post(endpoint: string, body?: any, reqOpts?: any): Observable<any> {
    return this.http.post(this.apiUrl + endpoint, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any):Observable<any> {
    return this.http.put(this.apiUrl + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete(this.apiUrl + endpoint + '/' + reqOpts)

  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.patch(this.apiUrl + endpoint, body, reqOpts);
  }


}
